import React, { FC } from 'react';
import { Button, Text } from '../../../../../components/common';
import styles from './ActionItem.scss';
import { IOuter } from './ActionItem.types';
import { useMMGRSettings } from '../../../../../utils/hoc/withMMGRSettings';

export const ActionItem: FC<IOuter> = ({ icon, label, onClick, dataHook }) => {
  const {
    mmgrSettings: { isUIAlignmentsEnabled },
  } = useMMGRSettings();

  return (
    <div className={styles.actionItemButton} data-hook={dataHook}>
      {isUIAlignmentsEnabled ? (
        <Button skin="light" prefixIcon={icon} onClick={onClick} dataHook="action-item" size={'small'}>
          <Text weight={'thin'} size={'small'} skin="primary">
            {label}
          </Text>
        </Button>
      ): (
        <Button skin="light" prefixIcon={icon} onClick={onClick} dataHook="action-item">
          {label}
        </Button>
      )}
    </div>
  );
};
